module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Another Adventure for Des Pond, Special Agent")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#chapter-1-bird-watching"
    }
  }, [_vm._v("Chapter 1: Bird Watching?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-2-the-meeting-of-agents"
    }
  }, [_vm._v("Chapter 2: The Meeting of Agents")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-3-in-foreign-lands-afar"
    }
  }, [_vm._v("Chapter 3: In Foreign Lands Afar")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-4-hardly-a-navy"
    }
  }, [_vm._v("Chapter 4: Hardly a Navy")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-5-there-must-be-some-other-country-involved.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5:\n                ‘There Must Be Some Other Country Involved.’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-6-10-downing-st-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: 10, Downing St London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-7-headquarters-of-mi5-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Headquarters of MI5,\n                London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-8-10-downing-st-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: 10, Downing St London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-9-somewhere-in-belarania",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Somewhere in\n                Belarania")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-10-10-downing-st-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: 10, Downing St\n                London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-11-the-thames-flood-barrier-near-greenwich",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: The\n                Thames Flood Barrier near Greenwich")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-12-10-downing-st-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: 10, Downing St\n                London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-13-pond-ponders-the-problem",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Pond Ponders the\n                Problem")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-14-10-downing-st-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: 10, Downing St\n                London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-15-pond-receives-a-telephone-call",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Pond Receives\n                a Telephone Call")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-16-10-downing-st-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: 10, Downing St\n                London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-17-dont-panic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Don’t Panic!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-18-all-are-in-despond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: All Are in Despond")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-19-row-row-row-your-boat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Row, Row, Row Your\n                Boat")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-20-stand-by-chaps",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: ‘Stand By, Chaps!’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-21-the-war-cabinet-meets",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: The War Cabinet\n                Meets")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-22-the-negotiations-begin",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: The Negotiations\n                Begin")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch025#chapter-23-diplomacy-the-pond-way",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Diplomacy, the Pond\n                Way")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch026#chapter-24-will-the-enemy-back-down",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Will the Enemy Back\n                Down?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#chapter-25-10-downing-st-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: 10, Downing St\n                London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#chapter-26-a-very-remote-hideaway-in-pandamia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: A Very\n                Remote Hideaway in Pandamia")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#chapter-27-hot-on-the-trail",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: Hot on the Trail")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#chapter-28-patience-is-a-virtue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Patience Is a\n                Virtue!")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#chapter-29-iron-bars-do-not-a-prison-make.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: ‘Iron Bars\n                Do Not a Prison Make.’")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#chapter-30-will-the-cavalry-arrive-in-the-nick-of-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 30:\n                Will the Cavalry Arrive in the Nick of Time?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#chapter-31-10-downing-st-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 31: 10, Downing St\n                London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#chapter-32-pond-is-bored-waiting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 32: Pond Is Bored\n                Waiting")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#chapter-33-pond-in-despond",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 33: Pond in Despond")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#chapter-34-someone-blunders",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 34: Someone Blunders")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#chapter-35-10-downing-st-london",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 35: 10, Downing St\n                London")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#chapter-36-the-prime-ministers-office",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 36: The Prime\n                Minister’s Office")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-917484e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0